import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Zap, Globe } from 'lucide-react';
export function HeroSection() {
  return <section id="inicio" className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-zumpago-dark" data-id="element-115">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-116">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
        backgroundSize: '32px 32px'
      }} data-id="element-117"></div>
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-zumpago-dark via-zumpago-dark to-gray-900 opacity-90" data-id="element-118"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32 w-full" data-id="element-119">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-120">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-121">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 text-white text-sm font-medium mb-6" data-id="element-122">
              <span className="flex h-2 w-2 rounded-full bg-zumpago-red" data-id="element-123"></span>
              Líderes en tecnología para recaudaciones
            </div>

            <h1 className="text-5xl lg:text-7xl font-extrabold text-white tracking-tight leading-[1.1] mb-6" data-id="element-124">
              Impulsa tu negocio con pagos{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-zumpago-red to-red-400" data-id="element-125">
                sin fronteras
              </span>
            </h1>

            <p className="text-lg lg:text-xl text-gray-300 mb-10 leading-relaxed max-w-xl" data-id="element-126">
              Soluciones de pago seguras, rápidas y escalables para empresas e
              instituciones. Facilitamos la recaudación utilizando tecnología de
              punta.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-127">
              <a href="#contacto" className="inline-flex justify-center items-center gap-2 px-8 py-4 rounded-full bg-zumpago-red text-white font-semibold text-lg hover:bg-red-700 transition-all shadow-lg shadow-red-900/20" data-id="element-128">
                Conócenos
                <ArrowRight className="w-5 h-5" data-id="element-129" />
              </a>
              <a href="#servicios" className="inline-flex justify-center items-center gap-2 px-8 py-4 rounded-full bg-white/10 text-white font-semibold text-lg hover:bg-white/20 transition-all backdrop-blur-sm" data-id="element-130">
                Ver Soluciones
              </a>
            </div>
          </motion.div>

          {/* Visual/Abstract Elements */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="hidden lg:block relative h-[500px]" data-id="element-131">
            {/* Abstract floating cards representing transactions */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md" data-id="element-132">
              <div className="relative z-20 bg-white/10 backdrop-blur-xl border border-white/20 p-6 rounded-2xl shadow-2xl transform -rotate-6 hover:rotate-0 transition-transform duration-500" data-id="element-133">
                <div className="flex justify-between items-center mb-6" data-id="element-134">
                  <div className="flex items-center gap-3" data-id="element-135">
                    <div className="w-10 h-10 rounded-full bg-zumpago-red/20 flex items-center justify-center" data-id="element-136">
                      <Zap className="w-5 h-5 text-zumpago-red" data-id="element-137" />
                    </div>
                    <div data-id="element-138">
                      <p className="text-white font-medium" data-id="element-139">
                        Su Pago fue Realizado
                      </p>
                      <p className="text-gray-400 text-sm" data-id="element-140">
                        Transacción exitosa
                      </p>
                    </div>
                  </div>
                  <span className="text-green-400 font-semibold" data-id="element-141">
                    $1,250.00
                  </span>
                </div>
                <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-142">
                  <div className="h-full bg-zumpago-red w-full" data-id="element-143"></div>
                </div>
              </div>

              <div className="absolute -bottom-12 -right-8 z-10 bg-gray-800/80 backdrop-blur-xl border border-gray-700 p-5 rounded-2xl shadow-xl transform rotate-3 w-64" data-id="element-144">
                <div className="flex items-center gap-3 mb-2" data-id="element-145">
                  <ShieldCheck className="w-5 h-5 text-blue-400" data-id="element-146" />
                  <p className="text-white text-sm font-medium" data-id="element-147">
                    Seguridad PCI DSS
                  </p>
                </div>
                <p className="text-gray-400 text-xs" data-id="element-148">
                  Encriptación de extremo a extremo activa.
                </p>
              </div>

              <div className="absolute -top-10 -left-10 z-10 bg-gray-800/80 backdrop-blur-xl border border-gray-700 p-5 rounded-2xl shadow-xl transform -rotate-3 w-56" data-id="element-149">
                <div className="flex items-center gap-3 mb-2" data-id="element-150">
                  <Globe className="w-5 h-5 text-purple-400" data-id="element-151" />
                  <p className="text-white text-sm font-medium" data-id="element-152">
                    Cobertura Regional
                  </p>
                </div>
                <div className="flex gap-1 mt-2" data-id="element-153">
                  <span className="w-6 h-4 bg-blue-600 rounded-sm block" data-id="element-154"></span>
                  <span className="w-6 h-4 bg-yellow-400 rounded-sm block" data-id="element-155"></span>
                  <span className="w-6 h-4 bg-red-600 rounded-sm block" data-id="element-156"></span>
                </div>
              </div>
            </div>

            {/* Decorative glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-zumpago-red/20 rounded-full blur-[100px] -z-10" data-id="element-157"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}